import React from 'react'
import { Container } from 'react-bootstrap'
import HomeProductsProvider from './HomeProductsProvider'

import ProductsGenrateor from '../ProductsGenrateor'

function Home({setSearch}) {
    return (
        <Container>
          
          {
            ProductsGenrateor.reduce((arr, product) => {
              if(!arr.includes(product.tag)) arr.push(product.tag)
              return arr
            }, []).map( tag => <HomeProductsProvider title={tag} productsData={ProductsGenrateor.filter(product => product.tag === tag)} setSearch={setSearch}/>
              )
          }
        </Container>
    )
}
export default Home
